/* Falgunni mega menu behaviour. Markup is rendered by snippets/pfm-mega.liquid. */
(function () {
  var header = document.querySelector('.pfh-header');
  var nav = document.querySelector('.pfm-nav');
  var panels = document.querySelector('[data-pfm]');
  var scrim = document.querySelector('[data-pfm-scrim]');
  var drawer = document.querySelector('[data-pfm-drawer]');
  var btn = document.querySelector('[data-pfm-open]');
  /* the header is its own stacking context, so the scrim and drawer must live on <body> to cover the page */
  if (scrim) document.body.appendChild(scrim);
  if (drawer) document.body.appendChild(drawer);

  if (header && nav && panels && scrim) {
    var triggers = Array.prototype.slice.call(nav.querySelectorAll('.pfm-trigger'));
    var canHover = matchMedia('(hover: hover)').matches;
    var openId = null, tOpen, tClose;

    var warm = function () {
      panels.querySelectorAll('img[loading=lazy]').forEach(function (i) { i.loading = 'eager'; });
    };
    window.addEventListener('load', function () { setTimeout(warm, 1200); }, { once: true });

    var setOpen = function (trg) {
      clearTimeout(tOpen); clearTimeout(tClose);
      openId = trg ? trg.id : null;
      triggers.forEach(function (t) {
        var on = t === trg;
        t.setAttribute('aria-expanded', on);
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (on) {
          p.hidden = false;
          requestAnimationFrame(function () { requestAnimationFrame(function () { p.classList.add('is-on'); }); });
        } else if (!p.hidden) {
          p.classList.remove('is-on');
          setTimeout(function () { if (openId !== t.id) p.hidden = true; }, 260);
        }
      });
      scrim.classList.toggle('is-on', !!trg);
    };
    var close = function () { setOpen(null); };

    triggers.forEach(function (t) {
      t.addEventListener('pointerenter', warm, { once: true });
      if (canHover) t.addEventListener('mouseenter', function () {
        clearTimeout(tClose);
        tOpen = setTimeout(function () { setOpen(t); }, openId ? 0 : 90);
      });
      t.addEventListener('focus', function () { setOpen(t); });
      t.addEventListener('click', function (e) {
        if (!canHover && openId !== t.id) { e.preventDefault(); setOpen(t); }
      });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault(); setOpen(t);
          var a = document.getElementById(t.getAttribute('aria-controls')).querySelector('a');
          if (a) a.focus();
        }
      });
    });
    nav.querySelectorAll('.pfm-plain').forEach(function (a) {
      a.addEventListener('mouseenter', function () { clearTimeout(tOpen); tClose = setTimeout(close, 120); });
    });
    if (canHover) {
      header.addEventListener('mouseleave', function () { clearTimeout(tOpen); tClose = setTimeout(close, 160); });
      header.addEventListener('mouseenter', function () { clearTimeout(tClose); });
    }
    header.addEventListener('focusout', function (e) { if (openId && e.relatedTarget && !header.contains(e.relatedTarget)) close(); });
    scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openId) { var t = document.getElementById(openId); close(); if (t) t.focus({ preventScroll: true }); }
    });
  }

  if (drawer) {
    var setDrawer = function (open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', !open);
      if (btn) btn.setAttribute('aria-expanded', open);
      document.documentElement.style.overflow = open ? 'hidden' : '';
    };
    if (btn) btn.addEventListener('click', function () { setDrawer(true); });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-pfm-close]')) return setDrawer(false);
      var b = e.target.closest('.pfd-btn');
      if (b) {
        var on = b.getAttribute('aria-expanded') !== 'true';
        drawer.querySelectorAll('.pfd-btn').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
        b.setAttribute('aria-expanded', on);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });
  }
})();
